import React from "react"
import { Analytics } from "@vercel/analytics/react"
import "./src/styles/global.css"

export const onClientEntry = () => {
  if (typeof document === "undefined") {
    return
  }

  const existingLink = document.head.querySelector('link[data-font="inter"]')
  if (existingLink) {
    return
  }

  const link = document.createElement("link")
  link.setAttribute("rel", "stylesheet")
  link.setAttribute(
    "href",
    "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;700&display=swap"
  )
  link.setAttribute("data-font", "inter")
  document.head.appendChild(link)
}

export const wrapRootElement = ({ element }) => (
  <>
    {element}
    <Analytics />
  </>
)
